window.crAnalytics = (function() {

	var envUrl;
	switch (E) {
		case 1: { // prod
			envUrl = '//metis.cityrealty.com/v1/analytics/click';
			break;
		}
		case 2: { // beta
			//yes, this is a server alias as workaround
			envUrl = '//beta-metis.cityrealty.com/v1/analytics/click';
			break;
		}
		case 3: { // staging
			envUrl = '//dev74-metis.cityrealty.com/v1/analytics/click';
			break;
		}
		case 4: { // dev
			envUrl = '//dev74-metis.cityrealty.com/v1/analytics/click';
			break;
		}
		case 5: { // local
			envUrl = '//dev74-metis.cityrealty.com/v1/analytics/click';
			break;
		}
		case 6: { // local
			envUrl = '//dev74-metis.cityrealty.com/v1/analytics/click';
			break;
		}
		default: {
			envUrl = '//dev74-metis.cityrealty.com/v1/analytics/click';
			break;
		}
	}


	var overwritePush = function() {
		if (typeof _gaq !== "undefined") {
			var gaq_push = _gaq.push;
			_gaq.push = function() {
				var args = arguments[0];

				if (args[0] === '_setCustomVar') {
					return;
				}

				// get the category and the custom data
				var category;
				var customData;
				if (args[1]) {
					var splitCat = args[1].split(';');
					category = splitCat[0].trim();
					var sCustomData = splitCat[1];
					if (sCustomData) {
						try {
							customData = JSON.parse(sCustomData);
						} catch (e) {
							// parsing error
							console.warn(e);
						}
					}
					args[1] = category;
				}

				// CR TRACKING
				if (args[0] === "_trackEvent" && _metis) {
					var data = {};
					// add custom data
					for (var property in _metis) {
						if (_metis.hasOwnProperty(property)) {
							data[property] = _metis[property];
						}
					}
					// var data = _metis;
					data.category = category;
					data.action = args[2];
					data.label = args[3];
					data.value = args[4];
					data.d = window.moment().utc().format('YYYY-MM-DD HH:mm:ss');

					// add custom data
					for (var property in customData) {
						if (customData.hasOwnProperty(property)) {
							data[property] = customData[property];
						}
					}

					// console.log(data);
					var xhttp = new XMLHttpRequest();
					xhttp.open("POST", envUrl, true);
					xhttp.setRequestHeader("Content-type", "application/json");
					xhttp.withCredentials = true;
					xhttp.send(JSON.stringify(data));
					xhttp.onreadystatechange = function() {
						if (this.readyState === 4 && this.status === 200) {
							// success
						}
					};
				}

				return gaq_push.apply(_gaq, arguments);
			};
		}
	};

	/**
	 * Retrieve the closest ancestor from a given node name
	 * @param  {HTMLElement} element     Element from where we start looking at the ancestor
	 * @return {HTMLElement}             The ancestor element found or null
	 */
	var findAncestorWithTrackingInfos = function(element) {
		while ((element = element.parentElement) && !(element.getAttribute('data-track-link') && element.getAttribute('data-track-link') === 'true'));
		return element;
	};

	/**
	 * Retrieve the closest ancestor from a given node name
	 * @param  {HTMLElement} element     Element from where we start looking at the ancestor
	 * @param  {String} ancestorNodeName Name of the node
	 * @return {HTMLElement}             The ancestor element found or null
	 */
	var findWidget = function(element) {
		while ((element = element.parentElement) && !element.getAttribute('data-component-info'));
		return element;
	};


	/**
	 * Retrieve the closest ancestor from a given node name
	 * @param  {HTMLElement} element     Element from where we start looking at the ancestor
	 * @param  {String} ancestorNodeName Name of the node
	 * @return {HTMLElement}             The ancestor element found or null
	 */
	var addDataToCategory = function(category, data) {
		// get the category and the custom data
		var categ;
		var customData;
		if (category) {
			var splitCat = category.split(';');
			categ = splitCat[0].trim();
			var sCustomData = splitCat[1];
			if (sCustomData) {
				try {
					customData = JSON.parse(sCustomData);
				} catch (e) {
					// parsing error
					console.warn(e);
				}
			}
			// merge data into customData
			if (customData) {
				for (var property in data) {
					if (data.hasOwnProperty(property)) {
						customData[property] = data[property];
					}
				}
			} else {
				customData = data;
			}
			category = categ;
			if (customData) {
				category += ';' + JSON.stringify(customData);
			}
		}

		return category;
	};


	/**
	 * [function description]
	 * @param  {[type]} event [description]
	 * @return {[type]}       [description]
	 */
	var callbackTrackEvent = function(event) {
		var target = event.target || event.srcElement;

		// Retrieve the link if a link has been clicked
		// Or a direct child of the link (such as img tag)
		var link;
		if (target.getAttribute('data-track-link') && target.getAttribute('data-track-link') === 'true') {
			link = target;
		}
		else {
			link = findAncestorWithTrackingInfos(target);
		}

		if (link) {
			// add widget id to the custom data
			var widget = findWidget(link);
			var widgetId = widget ? widget.getAttribute('data-component-info') : null;
			var data = {};
			if (widgetId) {
				var widgetInfos = widgetId.split(';');
				var main = widgetInfos[0].split('-');
				var extra = widgetInfos[1];

				var type = main[0];
				var id = main[1];
				if (type === 'listing') {
					data.l = id;
				} else if (type === 'building') {
					data.b = id;
				} else if (type === 'article') {
					data.ma = id;
				}

				if (extra) {
					extra = extra.split('-');
					var extraType = extra[0];
					var extraId = extra[1];

					if (extraType === 'building') {
						data.b = extraId;
					}
				}
			}

			// google analytics tracker
			// console.log(link.getAttribute('data-track-category'), link.getAttribute('data-track-action'), link.getAttribute('data-track-label'));
			var category1 = addDataToCategory(link.getAttribute('data-track-category'), data);
			_gaq.push( [ "_trackEvent", category1, link.getAttribute('data-track-action'), link.getAttribute('data-track-label')]);

			// call a second action if set
			if (link.getAttribute('data-track-link-2') && link.getAttribute('data-track-link-2') === 'true') {
				// console.log(link.getAttribute('data-track-category-2'), link.getAttribute('data-track-action-2'), link.getAttribute('data-track-label-2'));
				var category2 = addDataToCategory(link.getAttribute('data-track-category-2'), data);
				_gaq.push( [ "_trackEvent", category2, link.getAttribute('data-track-action-2'), link.getAttribute('data-track-label-2')]);
			}

			// call a second action if set
			if (link.getAttribute('data-track-link-3') && link.getAttribute('data-track-link-3') === 'true') {
				var category3 = addDataToCategory(link.getAttribute('data-track-category-3'), data);
				_gaq.push( [ "_trackEvent", category3, link.getAttribute('data-track-action-3'), link.getAttribute('data-track-label-3')]);
			}

			// Prevent default behaviour and put a delay before redirection (prevent missing tracking info on logout)
			// trim white spaces
			var href = link.getAttribute('href') ? link.getAttribute('href').trim() : undefined;
			var isLogout = (href && href.indexOf('/site/logout') >= 0);
			if (isLogout) {
				event.preventDefault();
				setTimeout(function(){
					window.location = link.getAttribute('href').trim();
				}, 1000);
			}

		}
	};

	return {

		init: function() {
			var onTouchEvent = false;
			var onTouchMove = false;

			// overwrite push method
			overwritePush();

			// track click
			document.addEventListener('click', function(event) {
				if (!onTouchEvent) {
					callbackTrackEvent(event);
				}
				onTouchEvent = false;
			});

			// For Mobile
			document.addEventListener('touchend', function(event) {
				if (!onTouchMove) {
					onTouchEvent = true;
					callbackTrackEvent(event);
				}
			});

			document.addEventListener('touchmove', function(event) {
				onTouchMove = true;
			});

			document.addEventListener('touchstart', function(event) {
				onTouchMove = false;
			});
		}

	};
})();
